import React from "react";
import { isNullOrWhiteSpace } from "../../shared/string";
import BackgroundBlockPattern, {
  BackgroundBlockPatternType
} from "../BackgroundBlockPattern";
import { PortableTextColorThemeProps } from "../PortableText/PortableText";
import HelpCard from "./HelpCard";
import { SanityHelpCardContact } from "./HelpCardContact";
import { Props as ContainerProps } from "./HelpCardContainer";
import { SanityHelpCardCta } from "./HelpCardCta";
import { SanityHelpCardIRContact } from "./HelpCardIRContact";
import { SanityHelpCardPressReleaseSignup } from "./HelpCardPressReleaseSignup";
import { SanityHelpCardText } from "./HelpCardText";
import { SanityHelpCardWithRating } from "./HelpCardWithRating";
export type SanityHelpCard =
  | SanityHelpCardContact
  | SanityHelpCardCta
  | SanityHelpCardIRContact
  | SanityHelpCardPressReleaseSignup
  | SanityHelpCardText
  | (ContainerProps & SanityHelpCardWithRating);

export interface HelpSingleCardProps {
  backgroundPattern?: BackgroundBlockPatternType;
  title?: string;
  subtitle?: string;
  portableTextColorThemeProps?: PortableTextColorThemeProps;
  width?: string;
  card?: SanityHelpCard[];
}

const HelpSingleCard = (props: HelpSingleCardProps) => {
  const { title, subtitle, portableTextColorThemeProps, backgroundPattern, width, card } =
    props;

  const {
    elementClasses: { h3Subheader: subtitleClasses = "text-subheader-primary" } = {}
  } = portableTextColorThemeProps || {};

  const cardWidthClassNames =
    width === "normal"
      ? "block m-auto max-w-full md:max-w-1/2"
      : "flex flex-col md:flex-row";
  return (
    <aside className="relative max-w-none px-0 z-0 anticimex-help-card-pair">
      {backgroundPattern && <BackgroundBlockPattern {...backgroundPattern} />}
      <div className="relative max-w-screen-xl mx-auto z-10 md:px-6">
        {!isNullOrWhiteSpace(title) && (
          <div className="mb-8 md:mb-16 px-4 md:px-0">
            <h2 className="text-current mb-2">{title}</h2>
            {!isNullOrWhiteSpace(subtitle) && (
              <h3
                className={`${subtitleClasses} text-base lg:text-xl uppercase font-bold`}
              >
                {subtitle}
              </h3>
            )}
          </div>
        )}
        <div className={cardWidthClassNames}>
          {!!card?.length && (
            <HelpCard
              {...card[0]}
              className="min-h-help-card-small lg:min-h-help-card"
              wideImage={width !== "normal"}
            />
          )}
        </div>
      </div>
    </aside>
  );
};

export default HelpSingleCard;
